import moment from "moment";
import { ButtonGroup, Paper, Table as TableBs } from "@mui/material";
import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom";
import React from "react";
import { getTime } from "helpers/GetTime";
import DatatableComponent from "../../helpers/DatatableComponent";
import { Link } from "react-router-dom";

const Table = (props) => {
  const { setSelected, selected, GetAllMeetings, notification, MarkAsRead, type, settings } = props;
  let history = useHistory();
  const [meetings, setMeetings] = React.useState([]);
  const columns = [
    {
      name: "Meeting.name",
      label: "Meeting",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "createdAt",
      label: "Created Time",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => getTime(value) ?? "",
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (id) => {
          let detail =
            notification?.filter((notif) => notif?.content?.id === id && notif?.content?.type === "meeting") ??
            [];
          return (
            <Button
              style={{ color: "#336767" }}
              onClick={() => {
                if (detail && detail[0]?.id) {
                  MarkAsRead(detail[0]?.id);
                }
                history.push(`/admin/minutes/details/${id}`);
              }}>
              <i className="fa fa-info-circle fa-md me-1" />
              Details{" "}
              {detail[0]?.content?.id === id ? (
                <span className="badge bg-green-400 rounded-pill ">
                  {"NEW"}
                </span>
              ) : null}
            </Button>
            // <Link
            //   to={
            //     //   () => {
            //     //   if (detail && detail[0]?.id) {
            //     //     MarkAsRead(detail[0]?.id);
            //     //   }
            //     //   history.push(`/admin/minutes/details/${id}`); 
            //     // }
            //     history.push(`/admin/minutes/details/${id}`)
            //   }>
            //   <i className="fa fa-info-circle fa-md me-1" /> Details{" "}
            //   {detail[0]?.content?.id === id ? (
            //     <span className="badge bg-green-400 rounded-pill ">
            //       {"NEW"}
            //     </span>
            //   ) : null}
            // </Link>
          );
        },
      },
    },
  ];

  return (
    <div>
      <DatatableComponent
        title="Minutes"
        viewColumns={false}
        search={false}
        searchfield={true}
        onMeeting={true}
        onMinutes={true}
        onCalendarChange={false}
        processData={(data) => {
          setMeetings(data.data);
          return data;
        }}
        columns={columns}
        url={`/api/minutes/datatable`}
        useMeetingUrl={true}
        // onAddNew={() => { history.push("/admin/create-minutes") }}
      //   processData={(data) => {
      //     setList(data.data);
      //     return data;
      // }} 
      />
    </div>
  );
};
const List = (props) => {
  return (
    <>
      <Table {...props} />
    </>
  );
};
export default List;
